import * as React from 'react';
import { Dispatch, SetStateAction, ChangeEvent } from 'react';
import { LegacyPaymentStatus, PaymentMethod } from 'types/plansales/billing';
import FilterLayout from 'components/common/searchfilter/FilterLayout';
import { SearchDateTerms } from 'types/common/searchfilter';
import { CheckObjectValue } from 'types/common';
import LegacyBillingFilterContents from './LegacyBillingFilterContents';

interface Props {
  dateInterval: string[];
  setDateInterval: Dispatch<SetStateAction<string[]>>;
  payStatus: CheckObjectValue;
  onChangePayStatus: (status: LegacyPaymentStatus) => (e: ChangeEvent<HTMLInputElement>) => void;
  paymentMethod: CheckObjectValue;
  onChangePaymentMethod: (status: PaymentMethod) => (e: ChangeEvent<HTMLInputElement>) => void;
  keyword: string;
  resetFilter: () => void;
  onChangeKeyword: (e: ChangeEvent<HTMLInputElement>) => void;
  getSearchResult: (newKeyword?: string) => void;
  selectedShortcut: SearchDateTerms | null;
  setSelectedShortcut: Dispatch<SetStateAction<SearchDateTerms | null>>;
  onKeyDownKeyword: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const LegacyBillingSearchFilter = ({
  dateInterval,
  setDateInterval,
  payStatus,
  paymentMethod,
  keyword,
  onChangePayStatus,
  onChangePaymentMethod,
  resetFilter,
  onChangeKeyword,
  getSearchResult,
  selectedShortcut,
  setSelectedShortcut,
  onKeyDownKeyword,
}: Props) => (
  <FilterLayout resetFilter={resetFilter} getSearchResult={getSearchResult}>
    <LegacyBillingFilterContents
      dateInterval={dateInterval}
      setDateInterval={setDateInterval}
      payStatus={payStatus}
      paymentMethod={paymentMethod}
      keyword={keyword}
      onChangePayStatus={onChangePayStatus}
      onChangePaymentMethod={onChangePaymentMethod}
      onChangeKeyword={onChangeKeyword}
      selectedShortcut={selectedShortcut}
      setSelectedShortcut={setSelectedShortcut}
      onKeyDownKeyword={onKeyDownKeyword}
    />
  </FilterLayout>
);

export default LegacyBillingSearchFilter;
